'use client';

import { c as _c } from "react/compiler-runtime";
import { ChangeEvent, KeyboardEvent, useCallback, useRef, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import type { Icon } from '@personly/libs-types';
import { InputIcon } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';
const parseQ = (searchParams: URLSearchParams) => searchParams.get('q') ?? '';
interface Props {
  placeholder: string;
  icon?: Icon;
}
const SearchInput = t0 => {
  const $ = _c(11);
  const {
    icon,
    placeholder
  } = t0;
  const searchParams = useSearchParams();
  const {
    range
  } = useValidators();
  const ref = useRef(null);
  let t1;
  if ($[0] !== searchParams) {
    t1 = parseQ(searchParams);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [q, setQ] = useState(t1);
  let t2;
  if ($[2] !== range) {
    t2 = range("SEARCH");
    $[2] = range;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchMinMax = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      if (!ref.current) {
        return;
      }
      if (e.key === "Enter") {
        ref.current.click();
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setQ(e_0.target.value);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onChange = t4;
  let t5;
  if ($[6] !== icon || $[7] !== placeholder || $[8] !== q || $[9] !== searchMinMax.max) {
    t5 = <InputIcon role="card" type="search" placeholder={placeholder} name="q" id="search" value={q} maxLength={searchMinMax.max} onChange={onChange} onKeyDown={handleKeyDown} icon={icon} label={placeholder} ref={ref} buttonType="submit" />;
    $[6] = icon;
    $[7] = placeholder;
    $[8] = q;
    $[9] = searchMinMax.max;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default SearchInput;